import { PublicApiClient } from '@/services/PublicApiClient.js'

export default {
  getInvoice(orderId, tckn) {
    return PublicApiClient.post(
      'invoice/' + orderId,
      { tckn },
      {
        responseType: 'arraybuffer'
      }
    )
      .then(response => {
        const blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  getLateFeeInvoice(orderId, tckn) {
    return PublicApiClient.post(
      'late-fee-invoice/' + orderId,
      { tckn },
      {
        responseType: 'arraybuffer'
      }
    )
      .then(response => {
        const blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  getOrderReceipt(orderId, tckn) {
    return PublicApiClient.post(
      'order-receipt/' + orderId,
      { tckn },
      {
        responseType: 'arraybuffer'
      }
    )
      .then(response => {
        const blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  getOrder(orderId, tckn) {
    return PublicApiClient.post('invoice/' + orderId + '/order', { tckn })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getOrderByHash(hash, tckn) {
    return PublicApiClient.post(`invoices/${hash}`, { tckn })
      .then(response => response)
      .catch(err => {
        throw err
      })
  },
  getInvoiceByHash(hash, tckn) {
    return PublicApiClient.post(`invoices/${hash}/invoice`, { tckn }, { responseType: 'arraybuffer' })
      .then(response => {
        const blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  getOrderReceiptByHash(hash, tckn) {
    return PublicApiClient.post(`invoices/${hash}/order-receipt`, { tckn }, { responseType: 'arraybuffer' })
      .then(response => {
        const blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  getLateFeeInvoiceByHash(hash, tckn) {
    return PublicApiClient.post(`invoices/${hash}/late-fee-invoice`, { tckn }, { responseType: 'arraybuffer' })
      .then(response => {
        const blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  getPaidPromissoryNote(orderId, tckn) {
    return PublicApiClient.post(
      'paid-promissory-note/' + orderId,
      { tckn },
      {
        responseType: 'arraybuffer'
      }
    )
      .then(response => {
        const blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  }
}
